import { useState } from "react";
import PotentialBox from "./PotentialBox";

function PotentialSection() {
  const [items, setItems] = useState([]);

  return (
    <section className="bg-gradient-to-r from-blue-100 to-blue-50 py-16">
      <h1 className="font-bold text-3xl sm:text-5xl text-gray-800 text-center mb-10">
        Empower Your Developers with Codeyai
      </h1>
      <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
        Reduce development time and costs with Codeyai's AI-powered code generation.
      </p>



      <div className="flex justify-center gap-6 mb-12 flex-wrap">
  <a
    href="https://www.youtube.com/watch?v=8itGMxnSJ0o"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90 transition-opacity"
  >
    <img
      src="https://img.youtube.com/vi/8itGMxnSJ0o/hqdefault.jpg"
      alt="Watch Codeyai Introduction"
      className="w-[340px] h-[235px] object-cover rounded shadow-lg"
    />
  </a>

  <a
    href="https://www.youtube.com/watch?v=FzBCWTIipyQ&t=15s"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90 transition-opacity"
  >
    <img
      src="https://img.youtube.com/vi/FzBCWTIipyQ/hqdefault.jpg"
      alt="Watch Codeyai Walkthrough"
      className="w-[340px] h-[235px] object-cover rounded shadow-lg"
    />
  </a>
</div>


      <footer className="bg-white p-4 text-center mt-12 shadow-md rounded">
        <p className="text-gray-600">
          Ready to dive in? <strong>Join Codeyai today!</strong>
        </p>
      </footer>
    </section>
  );
}

export default PotentialSection;
